/* eslint-disable */
import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Header } from '../../ui/header';
import { DropdownMenuSimple } from '../../ui/dropdown-menu-simple';
import { PATH_HOME } from '../../../routes/paths';
import { getPublicAssetUrl } from '../../../utils/publicAsset';

// ---------------------------------------------------------------------------
// Dropdown menus for each nav section
// ---------------------------------------------------------------------------

const aboutMenu = (
  <DropdownMenuSimple
    items={[
      { title: 'Our Story', description: 'Learn about Reality Fence', href: PATH_HOME.about },
      { title: 'Blog', description: 'News and updates', href: PATH_HOME.blogs },
    ]}
  />
);

const contactMenu = (
  <DropdownMenuSimple
    items={[
      { title: 'Contact Us', description: 'Get in touch with our team', href: PATH_HOME.contact },
    ]}
  />
);

const fencesMenu = (
  <DropdownMenuSimple
    items={[
      { title: 'Our Fences', description: 'Browse our fence catalog', href: PATH_HOME.ourfences },
      { title: 'AR Experience', description: 'Visualize fences in AR', href: PATH_HOME.arpage },
    ]}
  />
);

const featuresMenu = (
  <DropdownMenuSimple
    items={[
      {
        title: 'Quotes & Materials',
        description: 'Automatic quotes and material lists',
        href: PATH_HOME.quotesAndMaterials,
      },
      {
        title: 'Marketplace',
        description: 'Browse and sell fence materials',
        href: PATH_HOME.marketplace,
      },
    ]}
  />
);

// ---------------------------------------------------------------------------
// StickyHeader — drop-in replacement using Untitled UI Header
// ---------------------------------------------------------------------------

export function StickyHeader({ containerRef }: { containerRef: React.RefObject<HTMLElement> }) {
  const { pathname } = useLocation();
  const isMarketplace = pathname.startsWith('/marketplace');

  const marketplaceLogo = (dark: boolean) => (
    <Link to="/marketplace" className="shrink-0">
      <div className="relative h-20 sm:h-24">
        <img
          className="h-20 sm:h-24 absolute inset-0 transition-opacity duration-300"
          style={{ opacity: dark ? 0 : 1 }}
          src={getPublicAssetUrl('/assets/images/home/rf-marketplace-logo.png')}
          alt="RealityFence Marketplace"
        />
        <img
          className="h-20 sm:h-24 absolute inset-0 transition-opacity duration-300"
          style={{ opacity: dark ? 1 : 0 }}
          src={getPublicAssetUrl('/assets/images/home/rf-marketplace-logo-white.png')}
          alt="RealityFence Marketplace"
        />
        <img
          className="h-20 sm:h-24 invisible"
          src={getPublicAssetUrl('/assets/images/home/rf-marketplace-logo.png')}
          alt=""
          aria-hidden="true"
        />
      </div>
    </Link>
  );

  return (
    <Header
      autoOpenMenu
      {...(isMarketplace ? { logo: marketplaceLogo } : {})}
      items={[
        { label: 'Home', href: '/' },
        { label: 'Features', href: PATH_HOME.features, menu: featuresMenu },
        { label: 'About', href: PATH_HOME.about, menu: aboutMenu },
        { label: 'Contact', href: PATH_HOME.contact, menu: contactMenu },
      ]}
    />
  );
}
